<template>
    <div class="flex flex-row gap-6 h-full justify-center" v-if="payment.status">
        <div class="flex flex-col h-full justify-center">
            <div class="card bg-base-200 m-4 w-[32rem] mx-auto">
                <div class="card-body items-center px-4 md:px-8">
                    <button class="btn btn-lg btn-circle pointer-events-none">
                        <CheckCircleIcon class="w-16 h-16 text-success" v-if="payment.status == 'complete'" />
                        <ExclamationCircleIcon class="w-16 h-16 text-error" v-else />
                    </button>
                    <h3 class="text-xl mt-2" :class="payment.status == 'complete' ? 'text-success' : 'text-error'">
                        {{ __(payment.status == 'complete' ? 'Payment Success' : 'Payment failed') }}
                    </h3>
                    <p class="text-neutral text-sm">
                        {{ __(payment.status == 'complete' ? 'Your payment has been successfully completed' :
                            'Your payment encountered an error') }}
                    </p>
                    <div class="card bg-base-100 mt-6 w-full">
                        <div class="card-body">
                            <div class="flex justify-between text-sm">
                                <span>{{ __('Transaction type') }}</span>
                                <span>{{ __('Purchase product') }}</span>
                            </div>
                            <div class="divider my-0"></div>
                            <div class="flex justify-between text-sm">
                                <span>{{ __('Fee paid') }}</span>
                                <span>{{ payment.amount?.toLocaleString() + ' ' + __('Toman') }}</span>
                            </div>
                            <div class="divider my-0"></div>
                            <div class="flex justify-between text-sm">
                                <span>{{ __('Payment Method') }}</span>
                                <span>{{ __(payment.method) }} <small v-if="payment?.gateway">({{ __(payment?.gateway?.capitalize()) }})</small></span>
                            </div>
                            <div class="divider my-0"></div>
                            <div class="flex justify-between text-sm">
                                <span>{{ __('Transaction ID') }}</span>
                                <span>{{ payment.ref_id || '---' }}</span>
                            </div>
                            <div class="divider my-0"></div>
                            <div class="flex justify-between text-sm">
                                <span>{{ __('Payment date') }}</span>
                                <span>{{ payment.date }}</span>
                            </div>
                        </div>
                    </div>
                    <router-link :to="{ name: 'orders' }" class="btn btn-primary w-full mt-4" v-if="payment.status == 'complete'">{{ __('View orders')
                        }}</router-link>
                        <a class="btn btn-info w-full mt-4" v-else :href="payment.link">{{ __('Repayment') }}</a>
                </div>
            </div>
        </div>
    </div>
    <Progressbar v-else-if="loading && !payment.id" />
    <NetworkError v-else-if="errors" @tryAgain="getPayment" />
</template>
<script setup>
import { ExclamationCircleIcon, CheckCircleIcon } from '@heroicons/vue/24/outline'
import { onMounted } from "vue";
import useHome from "../../composables/shop/home";
const { getPayment, payment, loading, errors, router } = useHome();
onMounted(() => getPayment());

</script>